"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CacheBindingInvalidationKind = void 0;
var CacheBindingInvalidationKind;
(function (CacheBindingInvalidationKind) {
    CacheBindingInvalidationKind["bindingAdded"] = "bindingAdded";
    CacheBindingInvalidationKind["bindingRemoved"] = "bindingRemoved";
})(CacheBindingInvalidationKind || (exports.CacheBindingInvalidationKind = CacheBindingInvalidationKind = {}));
//# sourceMappingURL=CacheBindingInvalidationKind.js.map